const o = {
  name: "ArrowDiagonalDown",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.4142 6.00015L8.41421 17.0002L16 17.0002L16 19.0002L5 19.0002L5 8.00015L7 8.00015L7 15.5859L18 4.58594L19.4142 6.00015Z" fill="currentColor"/>
</svg>
  `
};
export {
  o as ArrowDiagonalDown
};
